module.exports = __webpack_public_path__ + "img/kabina.3cf11e1d.jpg";